import { createSlice } from '@reduxjs/toolkit'

interface TaskState {
  isAll: boolean
  pauseEnabled: boolean
  pauseWeek: number[]
  startTime: {
    hour: number
    minute: number
    second: number
  }
  endTime: {
    hour: number
    minute: number
    second: number
  }
}

const initialState: TaskState = {
  isAll: false,
  pauseEnabled: false,
  pauseWeek: [],
  startTime: {
    hour: 0,
    minute: 0,
    second: 0,
  },
  endTime: {
    hour: 0,
    minute: 0,
    second: 0,
  },
}

export const parseTime = timeString => {
  const [hour, minute, second] = timeString.split(':').map(Number)
  return {
    hour: hour || 0,
    minute: minute || 0,
    second: second || 0,
  }
}

// 判断当前时间是否在时间段内
export const isTimeInRange = (currentTime, startTime, endTime) => {
  // 将时分秒转换为总秒数
  const currentTotalSeconds = currentTime.hour * 3600 + currentTime.minute * 60 + currentTime.second
  const startTotalSeconds = startTime.hour * 3600 + startTime.minute * 60 + startTime.second
  const endTotalSeconds = endTime.hour * 3600 + endTime.minute * 60 + endTime.second

  return currentTotalSeconds >= startTotalSeconds && currentTotalSeconds <= endTotalSeconds
}

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setAll: (state, action) => {
      state.isAll = action.payload
    },
    setPauseEnabled: (state, action) => {
      state.pauseEnabled = action.payload
    },
    setPauseWeek: (state, action) => {
      state.pauseWeek = action.payload
    },
    setStartTime: (state, action) => {
      state.startTime = action.payload
    },
    setEndTime: (state, action) => {
      state.endTime = action.payload
    },
  },
})

export const { setAll, setPauseWeek, setPauseEnabled, setStartTime, setEndTime } = taskSlice.actions

export default taskSlice.reducer
